import { useEffect } from 'react'

export default ({ pageViewHandlers }) => (WrappedComponent) => {
  return (props) => {
    useEffect(() => {
      pageViewHandlers.forEach((handler) => handler(props.location.pathname))
    }, [props.location.pathname, pageViewHandlers])

    return <WrappedComponent {...props} />
  }
}
